// extracted by mini-css-extract-plugin
export default {"container":"DocumentsModal_container__dJE9d","text":"DocumentsModal_text__iO1z6"};